import axios from "axios";
import { DataResponse, PaginatedResponse } from "models/common/responseObjects";
import { Owner, OwnerView } from "models/dbModels/owners/Owner";
import { OwnersSearchFilterQuery } from "models/filters/owners/OwnersSearchFilterQuery";

export class OwnersApi {
    static Search = async (query: OwnersSearchFilterQuery) => axios.post<PaginatedResponse<OwnerView[]>>(`api/v1/Owners/Search`, query);
    static Add = async (query: Owner[]) => axios.post<DataResponse<number[]>>(`api/v1/Owners/Add`, query);
    static Update = async (query: Owner[]) => axios.post<DataResponse<boolean>>(`api/v1/Owners/Update`, query);
}